export default "__VITE_ASSET__f58dad7b__"